module.exports = __webpack_public_path__ + "iiif-redux.9807f7e2.png";